import { configs } from "configs";
import { isDeveloperPortalMode } from "core/AppModeContext";

/**
 * Resolves the default language for the current app context.
 *
 * The Developer Portal (KSA / bayut) defaults to Arabic, while every other
 * surface keeps the agency's primary language (`configs.languages[0]`). The
 * portal is detected by host via `isDeveloperPortalMode()`, so the shared
 * `bayut` config is not reordered and FMS/RMS are unaffected. If the resolved
 * agency config has no Arabic entry (e.g. `zd`), we fall back to the primary
 * language so the portal never points at a locale the tenant can't render.
 */
export const getDefaultLanguage = () => {
  if (isDeveloperPortalMode()) {
    const arabic = configs.languages.find((language) => language.key === "ar");
    if (arabic) {
      return arabic;
    }
  }
  return configs.languages[0];
};

export const getDefaultLanguageKey = () => getDefaultLanguage().key;
